import { useState, useEffect } from "react";
import { useConversation } from "@11labs/react";
import { evenlabsApi } from "../../../../services/evenlabs.service";

const useElevenLabs = () => {
  const [signedUrl, setSignedUrl] = useState("");
  const [elevenLabsClient, setElevenLabsClient] = useState(null);
  const [conversationId, setConversationId] = useState("");

  const { startSession, endSession, isSpeaking } = useConversation({
    onConnect: () => console.log("Connected"),
    onDisconnect: () => console.log("Disconnected"),
    onMessage: onRecieveMessages,
    onError: (error) => console.log("Error:", error),
  });

  function onRecieveMessages(message) {
    // const mockMessage1 = [
    //   {
    //     source: "ai",
    //     message:
    //       "Antes de iniciar la conversacion, importante confirmar esta informacion: Curso 5-A , Estudiantes: 20  y les gusta el futbol",
    //   },
    // ];
    // const mockMessage2 = [
    //   {
    //     source: "user",
    //     message: "Sí, correcto.",
    //   },
    // ];
    // const mockMessage3 = [
    //   {
    //     source: "ai",
    //     message:
    //       "¡Perfecto! ¿En qué puedo ayudarte hoy con respecto a este grupo de estudiantes?",
    //   },
    // ];
    console.log("Received message:", message);
  }

  useEffect(() => {
    const init = async () => {
      const { res, client } = await evenlabsApi();
      setElevenLabsClient(client);
      setSignedUrl(res.signed_url);
    };
    init();
  }, []);

  const handleStartConversation = async () => {
    if (elevenLabsClient) {
      const cid = await startSession({
        signedUrl,
        dynamicVariables: {
          id: "Cambia el nombre de fernando por diego y cambia el porcentaje del ejercicio a el 20% y cambia el dispositivo Iphone por un android",
        },
      });
      setConversationId(cid);
    }
  };

  const handleEndSession = async () => {
    await endSession();
    setConversationId("");
  };

  return {
    signedUrl,
    elevenLabsClient,
    conversationId,
    isSpeaking,
    handleStartConversation,
    handleEndSession,
  };
};

export default useElevenLabs;